// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tbljtxwglebvhjxzjqod.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRibGp0eHdnbGVidmhqeHpqcW9kIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQzOTIyMTMsImV4cCI6MjA0OTk2ODIxM30.hbMhseN91fHKhefskxo5d0ZuAPPmFKlSq-6S3dvJOUs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);